import {
    getErrorBackground,
    getErrorBorderColor,
    getErrorFontColor,
    getErrorIcon,
    getErrorText,
    useUser
} from "utils";
import { Link } from "react-router-dom";
import {observer} from "mobx-react-lite";
interface IDisplayError {
  error: string;
  isPremium?: boolean;
}

export const DisplayError: React.FC<IDisplayError> = observer((props) => {
    const user = useUser()
    return <div
      className="alert__container"
      style={{
          backgroundColor: getErrorBackground(props.error),
          color: getErrorFontColor(props.error),
          borderColor: getErrorBorderColor(props.error)
      }}
  >
      {
          getErrorIcon(props.error)
      }
      <span
          className='alert__text'
          style={{
              color: getErrorFontColor(props.error)
          }}
      >
          {getErrorText(props.error, props.isPremium)}.
      </span>
      {
        user?.subscription === 'Free' && !(getErrorText(props.error, props.isPremium).includes('Not enough text')) ? <Link to="/main/subscription" className="alert__text" style={{
            color: getErrorFontColor(props.error)
        }}>Upgrade</Link> : <></>
      }
  </div>
})